// Package imports:
import React, { useState } from 'react';
import cx from 'classnames';
import NumberFormat, { NumberFormatProps } from 'react-number-format';

type InputType = 'input' | 'numberFormat' | 'textArea';
type InputSizes = 'sm' | 'lg';
type TextAlign = 'left' | 'center' | 'right';

type InputProps = React.InputHTMLAttributes<HTMLInputElement>;
type TextAreaProps = React.TextareaHTMLAttributes<HTMLTextAreaElement>;
interface IOwnProps {
    inputType?: InputType,
    inputSize?: InputSizes,
    textAlign?: TextAlign,
    label?: string,
    shortLabel?: string
};

type Props = IOwnProps & NumberFormatProps & InputProps & TextAreaProps;

const Input: React.FC<Props> = ({
    // Custom props
    inputType = 'input',
    inputSize = 'lg',
    textAlign = 'left',
    label,
    shortLabel,
    // Element props
    id,
    className,
    style,
    onFocus,
    onBlur,
    value,
    ...props
}) => {
    const [isFocused, setIsFocused] = useState(false);
    const focus = () => setIsFocused(true);
    const blur = () => setIsFocused(false);


    // Props that overwrite native element props.
    const elementProps = {
        id,
        value,
        style: {
            ...style,
            textAlign: textAlign
        },
        onFocus: (e: React.FocusEvent<HTMLInputElement & HTMLTextAreaElement, Element>) => {
            if (onFocus) onFocus(e);
            focus();
        },
        onBlur: (e: React.FocusEvent<HTMLInputElement & HTMLTextAreaElement, Element>) => {
            if (onBlur) onBlur(e);
            blur();
        }
    }

    return (
        <div className={cx('KCL_input', inputSize, className, {
            'is-focused': isFocused,
            'has-value': (value !== undefined && value !== null && value.toString().length > 0),
            'is-disabled': props.disabled
        })}>
            {inputType === 'numberFormat'
                ? <NumberFormat
                    {...elementProps}
                    {...(props as NumberFormatProps)}
                />
                : inputType === 'input'
                ? <input
                    {...elementProps}
                    {...(props as InputProps)}
                />
                : <textarea
                    {...elementProps}
                    {...(props as TextAreaProps)}
                />
            }
            {label && (
                <label
                    className="input__label"
                    htmlFor={id}
                >
                    <span className="main-label">{label}</span>
                    <span className="short-label">{shortLabel ?? label}</span>
                </label>
            )}
        </div>
    );
}

export default (Input);